import {
    CartImpressionTrackingInfo,
    CartImpressionTrackingInfoItem,
    CartImpressionTrackingInfoPromotion
} from "@omni/types/components/tracking/tracking-info/impression/cartImpression.trackingInfo";
import { ArrayMapper } from "@omni/types/utils/arrayMapper";
import { ModelMapper } from "@omni/types/utils/modelMapper";
import { pick } from "@omni/utils/object.utils";

import {
    CartItemModel,
    CartModel,
    CartPromotionModel
} from "@/redux/modules/api/data/cart/@types/cart.model";

const warrantyProductInfo = {
    name: "Waarborg pallet",
    analytics: {
        productTitle: "Waarborg pallet",
        superCategoryCode: "waarborg",
        superCategoryName: "Waarborg"
    }
};

export const toCartImpressionTrackingInfoPromotion: ModelMapper<
    CartPromotionModel,
    CartImpressionTrackingInfoPromotion
> = (item) => {
    return pick(item, ["id"]);
};

export const toCartImpressionTrackingInfoItem: ArrayMapper<
    CartItemModel,
    CartImpressionTrackingInfoItem
> = (item, index) => {
    const { productTitle = "", superCategoryCode = "" } = item.analytics || {};

    const reduction =
        (item.strikethroughPrice ? item.strikethroughPrice : item.salesPrice) -
        item.salesPrice;

    return {
        name: productTitle || item.title,
        id: item.sku,
        ean: item.ean,
        category: superCategoryCode,
        price: item.salesPrice,
        unitPrice: item.salesPrice,
        tax: "21%",
        reduction: reduction,
        currencyCode: "EUR",
        quantity: item.quantity,
        url: item.url,
        placement: index + 1,
        brand: item.brandName || ""
    };
};

export const toCartImpressionTrackingInfo: ModelMapper<
    CartModel,
    CartImpressionTrackingInfo
> = (cart) => {
    const setWarranty = (item: CartItemModel) => {
        if (item.warrantyDeposit) {
            item.title = item.title || warrantyProductInfo.name;
            item.analytics = item.analytics || warrantyProductInfo.analytics;
        }
        return item;
    };

    return {
        name: "cart quickview",
        totalPrice: cart.totalPrice,
        promotions: cart.promotions.map(toCartImpressionTrackingInfoPromotion),
        globalDiscounts: cart.globalDiscounts,
        items: cart.items
            ?.map(setWarranty)
            .filter((item) => item.hasProduct)
            .map(toCartImpressionTrackingInfoItem)
    };
};
